import { userConstants } from '../constants/actionTypes'

const initialState = {
  isFetching: false,
  hasSpartaVehicle: false,
  applicationMaintenanceStatus: {
    isApplicationOnMaintenance: false,
    maintenanceTitle: '',
    maintenanceMessage: '',
  },
  isAtSettlement: false,
}

export function user(state = initialState, action) {
  switch (action.type) {
    case userConstants.FETCH_USER_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case userConstants.FETCH_USER_SUCCESS:
      return {
        ...action.user.customer,
        isFetching: false,
        isGov: action.user.parentOrganisationERCode === 'QLDGOVT',
        applicationMaintenanceStatus: action.user.applicationMaintenanceStatus,
        hasSpartaVehicle: action.user.hasSpartaVehicle,
        isAtSettlement: action.user.isAtSettlement
          ? action.user.isAtSettlement
          : state.isAtSettlement,
      }
    case userConstants.FETCH_USER_ERROR:
      return {
        isFetching: false,
        opportunityId: state.opportunityId,
        errorMessage: action.errorMessage,
      }
    default:
      return state
  }
}
